import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

import { InstructionsIntroText, InstructionsLink } from '../connect-csv-provider.styled';
import { DropZoneInstructionsComponentProps } from '../types';

export const RipplingInstructions = ({
  instructionsUrl,
  templateCsvUrl,
}: DropZoneInstructionsComponentProps): React.ReactElement => {
  const ripplingInstructionsId = useAnalyticId(AnalyticIdentifier.RTC_EXPENSES_RIPPLING_HELP);
  const ripplingCsvDownloadLinkId = useAnalyticId(AnalyticIdentifier.RTC_RIPPLING_CSV_DOWNLOAD_LINK);
  return (
    <>
      <InstructionsIntroText as="p" fontSize="sm" fontWeight="normal">
        Because Rippling does not support direct connections, follow the visual instructions below to generate your{' '}
        <InstructionsLink target="_blank" href={templateCsvUrl} id={ripplingCsvDownloadLinkId}>
          Yearly Payroll Report
        </InstructionsLink>
        .
      </InstructionsIntroText>

      <iframe
        id={ripplingInstructionsId}
        src={instructionsUrl}
        width="100%"
        height="640"
        allowFullScreen
        frameBorder="0"
      ></iframe>
    </>
  );
};
